import { useSearchHotkey } from "./useSearchHotkey";

/**
 * Renderless carrier for the global Cmd/Ctrl+F handler.
 *
 * Mounted once at the app root (`main.tsx`) rather than per shell — there are
 * five shells (dashboard / event / app / user / template) and we want exactly
 * one listener, not one per mounted shell.
 */
export function SearchHotkey(): null {
  useSearchHotkey();
  return null;
}
